module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "toast",
    class: _vm.position ? 'toast-' + _vm.position : 'toast-center'
  }, [(_vm.mask) ? _c('div', {
    staticClass: "toast-mask"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "toast-content"
  }, [_vm._v(_vm._s(_vm.content))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6564af2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast/main.vue
// module id = 832
// module chunks = 1